<template>
  <div
    class="form-no-messages"
    style="position:relative"
  >
    <CurrentStockComponent goods-type="S0106" />
  </div>
</template>
<script>
import CurrentStockComponent from './CurrentStockComponent'
// import ConstDef from '../../../../MesSmartVue/src/share/ConstDef'
// import HttpService from '../../share/service/HttpService'
// import AesCrypto from '../../share/service/AesCrypto'

export default {
  name: 'CurrentStockTab',
  components: {
    CurrentStockComponent
  },
  data: function () {
    return {
      isLoading: false,
      userInfo: null
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
